module.exports = __webpack_public_path__ + "static/media/bg.373b4f38.png";